export default __webpack_public_path__ + "static/apple-icon-144x144-d0b0c86590658b3b50330cfb8396c42d.png";